import React from "react";
import {RedactCommentary} from "../../../redact/RedactCommentary";
import {ExpandableText} from "../../../elements/ExpandableText";
import {logAction} from "../../../../logging/logEvent";

const limit = 500;

export const Commentary = ({idea}) => {
    const {openComment, ideaId, authorName, recommendation: {bloomberg, direction}} = idea;

    const onSeeMore = (seeMore) => {
        logAction({
            type: seeMore ? "IDEA_COMMENTARY_SEE_MORE" : "IDEA_COMMENTARY_SEE_LESS",
            ideaId,
            authorName,
            bloomberg,
            direction
        })
    };

    return (
        <div className="t-commentary">
            <RedactCommentary>
                <ExpandableText text={openComment}
                                onClick={onSeeMore}
                                limit={limit}
                                fontSize="14px"
                                className="t-comment-text"/>
            </RedactCommentary>
        </div>
    )
};
